









import Vue from 'vue'

export default Vue.extend({
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: !this.collapsed
    }
  },
  computed: {
    label: function(): string {
      return (this.show) ? '>' : '<'
    }
  },
  methods: {
    toggleSideNav: function() {
      this.show = !this.show
      this.$emit('toggle')
    }
  },
  watch: {
    collapsed(newCollapse){
      this.show = !newCollapse
    }
  }
})
